
// import React, { useState } from "react";
// import { MDBCard, MDBCardBody, MDBCardHeader } from "mdbreact";
// import { ToastContainer, toast } from "react-toastify";
// import Axios from "axios";
// import { useHistory } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";
// import "./UserCreate.css";
// import config from "../../config";

// const DashboardUserCreat = ({ onUserAdded }) => {
//   const history = useHistory();
//   const [error, setError] = useState("");
//   const [mobileError, setMobileError] = useState("");
//   const [data, setData] = useState([]);
//   const [formValues, setFormValues] = useState({
//     firstname: "",
//     lastname: "",
//     email: "",
//     phonenumber: "",
//     gender: "",
//     city: "",
//     state: "",
//     region: "",
//     role: "",
//     password: "",
//     loginId: "", // New field for Login ID
//   });


//   const onChangeA = (e, ctrlName, ctrlValue) => {
//     setFormValues((prevFormValues) => ({
//       ...prevFormValues,
//       [ctrlName]: ctrlValue,
//     }));
//   };

//   const CITY_STATE_MAP = {
//     Vishakapatnam: "Andhra Pradesh",
//     Sonipat: "Haryana",
//   };

//   const handleCityChange = (e) => {
//     const selectedCity = e.target.value;
//     setFormValues((prevFormValues) => ({
//       ...prevFormValues,
//       city: selectedCity,
//       state: CITY_STATE_MAP[selectedCity] || "",
//     }));
//   };

//   const onChangealpha = (e, ctrlName, ctrlValue) => {
//     const alphabetRegex = /^[a-zA-Z]*$/; // Allows only alphabets
//     if (alphabetRegex.test(ctrlValue)) {
//       setFormValues((prevFormValues) => ({
//         ...prevFormValues,
//         [ctrlName]: ctrlValue,
//       }));
//     }
//   };

//   const isValidEmail = (email) => {
//     return /\S+@\S+\.\S+/.test(email);
//   };

//   const handleMobileChange = (e) => {
//     const regex = /^[0-9]{10}$/;
//     const value = e.target.value;
//     if (!regex.test(value)) {
//       setMobileError("* Enter Valid Mobile No");
//     } else {
//       setMobileError("");
//     }
//     onChangeA(e, "phonenumber", value);
//   };

//   const handleEmailChange = (e) => {
//     const value = e.target.value;
//     if (!isValidEmail(value)) {
//       setError("Invalid Email");
//     } else {
//       setError("");
//     }
//     onChangeA(e, "email", value);
//   };

//   const addUser = (e) => {
//     e.preventDefault();
//     console.log(formValues);
//     // Check if any required fields are missing
//     const missingFields = Object.keys(formValues).filter((key) => {
//       return key !== "loginId" && !formValues[key];
//     });

//     if (missingFields.length > 0) {
//       toast.error("Please fill in all required fields.");
//       return;
//     }

//     // Validate Login ID only if the role is 'Mobile App user'
//     if (formValues.role === "4" && formValues.loginId.trim() === "") {
//       toast.error("Login ID is required for Mobile App user.");
//       return;
//     }

//     // Perform email and phone number validations
//     if (error || mobileError) {
//       toast.error("Please correct the errors in the form.");
//       return;
//     }

//     const payload = {
//       FIRST_NAME: formValues.firstname,
//       LAST_NAME: formValues.lastname,
//       MOBILE: formValues.phonenumber,
//       EMAIL: formValues.email,
//       GENDER: formValues.gender,
//       CITY: formValues.city,
//       STATE: formValues.state,
//       REGION: formValues.region,
//       PASSWORD: formValues.password,
//       ROLE: formValues.role,
//       LOGIN_ID: formValues.role === "4" ? formValues.loginId : null,
//       Status: 0,
//     };

//     Axios.post(`${config.baseUrl}/addUser`, payload, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((response) => {
//         if (response.status === 200) {
//           setData([...data, payload]);

//           // Reset form values
//           setFormValues({
//             firstname: "",
//             lastname: "",
//             email: "",
//             phonenumber: "",
//             gender: "",
//             city: "",
//             state: "",
//             region: "",
//             password: "",
//             role: "",
//             loginId: "",
//           });
//           toast.success("User Added Successfully");
//         } else if (response.status === 301) {
//           toast.error(response.data.error.message);
//         }
//       })
//       .catch((error) => {
//         toast.error(
//           error.response?.data?.error?.message ||
//           "Error adding user. Please try again."
//         );
//       });
//   };

//   return (
//     <div>
//       <h3 className="pageheading">User Creation</h3>
//       <MDBCard
//         style={{
//           background: "#F3F3F3",
//           borderRadius: "12px",
//           boxShadow: "none",
//         }}
//       >
//         <MDBCardHeader className="userCreateCardHeader" id="UserCreation">
//           <p>User Details</p>
//         </MDBCardHeader>
//         <MDBCardBody>
//           <form className="user-form">
//             <div className="user-form-container">
//               <div className="user-form-row">
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="firstname">
//                     First Name *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="firstname"
//                     name="firstname"
//                     value={formValues.firstname}
//                     placeholder="First Name"
//                     onChange={(e) => onChangealpha(e, "firstname", e.target.value)}
//                   />
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="lastname">
//                     Last Name *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="lastname"
//                     name="lastname"
//                     value={formValues.lastname}
//                     placeholder="Last Name"
//                     onChange={(e) => onChangealpha(e, "lastname", e.target.value)}
//                   />
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="email">
//                     Email *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="email"
//                     name="email"
//                     value={formValues.email}
//                     placeholder="Email"
//                     onChange={handleEmailChange}
//                   />
//                 </div>
//               </div>
//               <div className="user-form-row">
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="mobile">
//                     Mobile No *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="mobile"
//                     name="mobile"
//                     value={formValues.phonenumber}
//                     placeholder="Phone Number"
//                     maxLength={10}
//                     onChange={handleMobileChange}
//                   />
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="gender">
//                     Gender *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="gender"
//                     value={formValues.gender}
//                     onChange={(e) => onChangeA(e, "gender", e.target.value)}
//                   >
//                     <option value="" disabled>
//                       Choose Gender
//                     </option>
//                     <option value="male">Male</option>
//                     <option value="female">Female</option>
//                     <option value="others">Others</option>
//                   </select>
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="city">
//                     City *
//                   </label>
//                   {/* <select
//                     className="user-form-select"
//                     id="city"
//                     name="city"
//                     value={formValues.city}
//                     onChange={(e) => onChangeA(e, "city", e.target.value)}
//                   > */}
//                   <select
//                     className="user-form-select"
//                     id="city"
//                     name="city"
//                     value={formValues.city}
//                     onChange={handleCityChange}
//                   >
//                     <option value="">Select City</option>
//                     <option value="Vishakapatnam">Vishakapatnam</option>
//                     <option value="Sonipat">Sonipat</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="user-form-row">
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="state">
//                     State *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="state"
//                     name="state"
//                     value={formValues.state}
//                     onChange={(e) => onChangeA(e, "state", e.target.value)}
//                   >
//                     <option value="">Select State</option>
//                     <option value="Andhra Pradesh">Andhra Pradesh</option>
//                     <option value="Haryana">Haryana</option>
//                   </select>
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="region">
//                     Region *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="region"
//                     name="region"
//                     value={formValues.region}
//                     onChange={(e) => onChangeA(e, "region", e.target.value)}
//                   >
//                     <option value="">Select Region</option>
//                     <option value="Urban">Urban</option>
//                     <option value="Rural">Rural</option>
//                   </select>
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="role">
//                     Role *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="role"
//                     value={formValues.role}
//                     // value={formValues.firstname}
//                     onChange={(e) => onChangeA(e, "role", e.target.value)}
//                   >
//                     <option value="" disabled>
//                       Select Role
//                     </option>
//                     <option value="0">Web Admin</option>
//                     <option value="10">Vishakapatnam Project SP</option>
//                     <option value="20">Sonipat Project SP</option>
//                     <option value="11">Vishakapatnam Data SP`</option>
//                     <option value="21">Sonipat Data SP</option>
//                     <option value="4">Mobile App user</option>{" "}
//                     {/* Mobile App user option */}
//                   </select>
//                 </div>
//               </div>
//               {/* Conditionally render Login ID field */}
//               <div className="user-form-row">
//                 {formValues.role === "4" && (
//                   <div className="user-form-field">
//                     <label className="user-form-label" htmlFor="loginId">
//                       Login ID *
//                     </label>
//                     <input
//                       className="user-form-input"
//                       type="text"
//                       id="loginId"
//                       name="loginId"
//                       placeholder="Login ID"
//                       value={formValues.loginId}
//                       onChange={(e) => onChangeA(e, "loginId", e.target.value)}
//                     />
//                   </div>
//                 )}
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="mobile">
//                     Password *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="password"
//                     name="password"
//                     placeholder="password"
//                     maxLength={10}
//                     value={formValues.password}
//                     onChange={(e) => onChangeA(e, "password", e.target.value)}
//                   />
//                 </div>{" "}
//               </div>
//             </div>
//             <button className="user-form-button" onClick={addUser}>
//               Add User
//             </button>
//           </form>

//           <ToastContainer />
//         </MDBCardBody>
//       </MDBCard>
//     </div>
//   );
// };

// export default DashboardUserCreat;
// import React, { useState, useEffect } from "react";
// import { MDBCard, MDBCardBody, MDBCardHeader } from "mdbreact";
// import { ToastContainer, toast } from "react-toastify";
// import Axios from "axios";
// import { useHistory } from "react-router-dom";
// import "react-toastify/dist/ReactToastify.css";
// import "./UserCreate.css";
// import config from "../../config";

// // Site -> State lookup used to auto-populate the State field
// const CITY_STATE_MAP = {
//   Vishakapatnam: "Andhra Pradesh",
//   Sonipat: "Haryana",
// };

// const DashboardUserCreat = ({ onUserAdded, editUser }) => {
//   const history = useHistory();
//   const [error, setError] = useState("");
//   const [mobileError, setMobileError] = useState("");
//   const [loginIdError, setLoginIdError] = useState("");
//   const [data, setData] = useState([]);
//   const [formValues, setFormValues] = useState({
//     firstname: "",
//     lastname: "",
//     email: "",
//     phonenumber: "",
//     gender: "",
//     city: "",
//     state: "",
//     region: "",
//     role: "",
//     password: "",
//     loginId: "", // New field for Login ID
//   });

//   // Populate the form when an existing user is passed in for editing
//   useEffect(() => {
//     if (editUser) {
//       setFormValues({
//         firstname: editUser.FIRST_NAME || "",
//         lastname: editUser.LAST_NAME || "",
//         email: editUser.EMAIL || "",
//         phonenumber: editUser.MOBILE || "",
//         gender: editUser.GENDER || "",
//         city: editUser.CITY || "",
//         state: editUser.STATE || "",
//         region: editUser.REGION || "",
//         role:
//           editUser.ROLE !== undefined && editUser.ROLE !== null
//             ? String(editUser.ROLE)
//             : "",
//         password: editUser.PASSWORD || "",
//         loginId: editUser.LOGIN_ID || "",
//       });
//     }
//   }, [editUser]);

//   const onChangeA = (e, ctrlName, ctrlValue) => {
//     setFormValues((prevFormValues) => ({
//       ...prevFormValues,
//       [ctrlName]: ctrlValue,
//     }));
//   };

//   const onChangealpha = (e, ctrlName, ctrlValue) => {
//     const alphabetRegex = /^[a-zA-Z]*$/; // Allows only alphabets
//     if (alphabetRegex.test(ctrlValue)) {
//       setFormValues((prevFormValues) => ({
//         ...prevFormValues,
//         [ctrlName]: ctrlValue,
//       }));
//     }
//   };

//   const isValidEmail = (email) => {
//     return /\S+@\S+\.\S+/.test(email);
//   };

//   const handleMobileChange = (e) => {
//     const regex = /^[0-9]{10}$/;
//     const value = e.target.value;
//     if (!regex.test(value)) {
//       setMobileError("* Enter Valid Mobile No");
//     } else {
//       setMobileError("");
//     }
//     onChangeA(e, "phonenumber", value);
//   };

//   const handleEmailChange = (e) => {
//     const value = e.target.value;
//     if (!isValidEmail(value)) {
//       setError("Invalid Email");
//     } else {
//       setError("");
//     }
//     onChangeA(e, "email", value);
//   };

//   // Auto-populate State whenever a Site/City is chosen
//   const handleCityChange = (e) => {
//     const selectedCity = e.target.value;
//     setFormValues((prevFormValues) => ({
//       ...prevFormValues,
//       city: selectedCity,
//       state: CITY_STATE_MAP[selectedCity] || "",
//     }));
//   };

//   // Login ID must be exactly 3 digits (Mobile App user only)
//   const handleLoginIdChange = (e) => {
//     const value = e.target.value;
//     if (/^\d{0,3}$/.test(value)) {
//       onChangeA(e, "loginId", value);
//       setLoginIdError(
//         value.length > 0 && value.length < 3
//           ? "* Login ID must be exactly 3 digits"
//           : ""
//       );
//     }
//   };

//   const addUser = (e) => {
//     e.preventDefault();
//     console.log(formValues);
//     // Check if any required fields are missing
//     const missingFields = Object.keys(formValues).filter((key) => {
//       return key !== "loginId" && !formValues[key];
//     });

//     if (missingFields.length > 0) {
//       toast.error("Please fill in all required fields.");
//       return;
//     }

//     // Validate Login ID only if the role is 'Mobile App user'
//     if (formValues.role === "4" && !/^\d{3}$/.test(formValues.loginId)) {
//       toast.error("Login ID must be exactly 3 digits for Mobile App user.");
//       return;
//     }

//     // Perform email and phone number validations
//     if (error || mobileError || loginIdError) {
//       toast.error("Please correct the errors in the form.");
//       return;
//     }

//     const payload = {
//       FIRST_NAME: formValues.firstname,
//       LAST_NAME: formValues.lastname,
//       MOBILE: formValues.phonenumber,
//       EMAIL: formValues.email,
//       GENDER: formValues.gender,
//       CITY: formValues.city,
//       STATE: formValues.state,
//       REGION: formValues.region,
//       PASSWORD: formValues.password,
//       ROLE: formValues.role,
//       LOGIN_ID: formValues.role === "4" ? formValues.loginId : null,
//       Status: 0,
//     };

//     Axios.post(`${config.baseUrl}/addUser`, payload, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((response) => {
//         if (response.status === 200) {
//           setData([...data, payload]);

//           // Reset form values
//           setFormValues({
//             firstname: "",
//             lastname: "",
//             email: "",
//             phonenumber: "",
//             gender: "",
//             city: "",
//             state: "",
//             region: "",
//             password: "",
//             role: "",
//             loginId: "",
//           });
//           toast.success("User Added Successfully");
//         } else if (response.status === 301) {
//           toast.error(response.data.error.message);
//         }
//       })
//       .catch((error) => {
//         toast.error(
//           error.response?.data?.error?.message ||
//           "Error adding user. Please try again."
//         );
//       });
//   };

//   return (
//     <div>
//       <h3 className="pageheading">User Creation</h3>
//       <MDBCard
//         style={{
//           background: "#F3F3F3",
//           borderRadius: "12px",
//           boxShadow: "none",
//         }}
//       >
//         <MDBCardHeader className="userCreateCardHeader" id="UserCreation">
//           <p>User Details</p>
//         </MDBCardHeader>
//         <MDBCardBody>
//           <form className="user-form">
//             <div className="user-form-container">
//               <div className="user-form-row">
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="firstname">
//                     First Name *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="firstname"
//                     name="firstname"
//                     value={formValues.firstname}
//                     placeholder="First Name"
//                     onChange={(e) => onChangealpha(e, "firstname", e.target.value)}
//                   />
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="lastname">
//                     Last Name *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="lastname"
//                     name="lastname"
//                     value={formValues.lastname}
//                     placeholder="Last Name"
//                     onChange={(e) => onChangealpha(e, "lastname", e.target.value)}
//                   />
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="email">
//                     Email *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="email"
//                     name="email"
//                     value={formValues.email}
//                     placeholder="Email"
//                     onChange={handleEmailChange}
//                   />
//                 </div>
//               </div>
//               <div className="user-form-row">
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="mobile">
//                     Mobile No *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="mobile"
//                     name="mobile"
//                     value={formValues.phonenumber}
//                     placeholder="Phone Number"
//                     maxLength={10}
//                     onChange={handleMobileChange}
//                   />
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="gender">
//                     Gender *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="gender"
//                     value={formValues.gender}
//                     onChange={(e) => onChangeA(e, "gender", e.target.value)}
//                   >
//                     <option value="" disabled>
//                       Choose Gender
//                     </option>
//                     <option value="male">Male</option>
//                     <option value="female">Female</option>
//                     <option value="others">Others</option>
//                   </select>
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="city">
//                     City *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="city"
//                     name="city"
//                     value={formValues.city}
//                     onChange={handleCityChange}
//                   >
//                     <option value="">Select City</option>
//                     <option value="Vishakapatnam">Vishakapatnam</option>
//                     <option value="Sonipat">Sonipat</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="user-form-row">
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="state">
//                     State *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="state"
//                     name="state"
//                     value={formValues.state}
//                     disabled
//                   >
//                     <option value="">Select State</option>
//                     <option value="Andhra Pradesh">Andhra Pradesh</option>
//                     <option value="Haryana">Haryana</option>
//                   </select>
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="region">
//                     Region *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="region"
//                     name="region"
//                     value={formValues.region}
//                     onChange={(e) => onChangeA(e, "region", e.target.value)}
//                   >
//                     <option value="">Select Region</option>
//                     <option value="Urban">Urban</option>
//                     <option value="Rural">Rural</option>
//                   </select>
//                 </div>
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="role">
//                     Role *
//                   </label>
//                   <select
//                     className="user-form-select"
//                     id="role"
//                     value={formValues.role}
//                     onChange={(e) => onChangeA(e, "role", e.target.value)}
//                   >
//                     <option value="" disabled>
//                       Select Role
//                     </option>
//                     <option value="0">Web Admin</option>
//                     <option value="10">Vishakapatnam Project SP</option>
//                     <option value="20">Sonipat Project SP</option>
//                     <option value="11">Vishakapatnam Data SP</option>
//                     <option value="21">Sonipat Data SP</option>
//                     <option value="4">Mobile App user</option>
//                   </select>
//                 </div>
//               </div>
//               {/* Conditionally render Login ID field */}
//               <div className="user-form-row">
//                 {formValues.role === "4" && (
//                   <div className="user-form-field">
//                     <label className="user-form-label" htmlFor="loginId">
//                       Login ID *
//                     </label>
//                     <input
//                       className="user-form-input"
//                       type="text"
//                       id="loginId"
//                       name="loginId"
//                       placeholder="Login ID"
//                       maxLength={3}
//                       value={formValues.loginId}
//                       onChange={handleLoginIdChange}
//                     />
//                     {loginIdError && (
//                       <span className="error-text">{loginIdError}</span>
//                     )}
//                   </div>
//                 )}
//                 <div className="user-form-field">
//                   <label className="user-form-label" htmlFor="mobile">
//                     Password *
//                   </label>
//                   <input
//                     className="user-form-input"
//                     type="text"
//                     id="password"
//                     name="password"
//                     placeholder="password"
//                     maxLength={10}
//                     value={formValues.password}
//                     onChange={(e) => onChangeA(e, "password", e.target.value)}
//                   />
//                 </div>{" "}
//               </div>
//             </div>
//             <button className="user-form-button" onClick={addUser}>
//               Add User
//             </button>
//           </form>

//           <ToastContainer />
//         </MDBCardBody>
//       </MDBCard>
//     </div>
//   );
// };

// export default DashboardUserCreat;

import React, { useState, useEffect } from "react";
import { MDBCard, MDBCardBody, MDBCardHeader } from "mdbreact";
import { ToastContainer, toast } from "react-toastify";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./UserCreate.css";
import config from "../../config";

// Site -> State lookup used to auto-populate the State field
const CITY_STATE_MAP = {
  Vishakapatnam: "Andhra Pradesh",
  Sonipat: "Haryana",
};

const DashboardUserCreat = ({ onUserAdded, editUser }) => {
  const history = useHistory();
  const [error, setError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [loginIdError, setLoginIdError] = useState("");
  const [data, setData] = useState([]);
  const [formValues, setFormValues] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    gender: "",
    city: "",
    state: "",
    region: "",
    role: "",
    password: "",
    loginId: "", // New field for Login ID
  });

  // Populate the form when an existing user is passed in for editing
  useEffect(() => {
    if (editUser) {
      setFormValues({
        firstname: editUser.FIRST_NAME || "",
        lastname: editUser.LAST_NAME || "",
        email: editUser.EMAIL || "",
        phonenumber: editUser.MOBILE || "",
        gender: editUser.GENDER || "",
        city: editUser.CITY || "",
        state: editUser.STATE || "",
        region: editUser.REGION || "",
        role:
          editUser.ROLE !== undefined && editUser.ROLE !== null
            ? String(editUser.ROLE)
            : "",
        password: editUser.PASSWORD || "",
        loginId: editUser.LOGIN_ID || "",
      });
    }
  }, [editUser]);

  const onChangeA = (e, ctrlName, ctrlValue) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [ctrlName]: ctrlValue,
    }));
  };

  const onChangealpha = (e, ctrlName, ctrlValue) => {
    const alphabetRegex = /^[a-zA-Z]*$/; // Allows only alphabets
    if (alphabetRegex.test(ctrlValue)) {
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        [ctrlName]: ctrlValue,
      }));
    }
  };

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleMobileChange = (e) => {
    const regex = /^[0-9]{10}$/;
    const value = e.target.value;
    if (!regex.test(value)) {
      setMobileError("* Enter Valid Mobile No");
    } else {
      setMobileError("");
    }
    onChangeA(e, "phonenumber", value);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    if (!isValidEmail(value)) {
      setError("Invalid Email");
    } else {
      setError("");
    }
    onChangeA(e, "email", value);
  };

  // Auto-populate State whenever a Site/City is chosen
  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      city: selectedCity,
      state: CITY_STATE_MAP[selectedCity] || "",
    }));
  };

  // Login ID must be exactly 3 digits (Mobile App user only)
  const handleLoginIdChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,3}$/.test(value)) {
      onChangeA(e, "loginId", value);
      setLoginIdError(
        value.length > 0 && value.length < 3
          ? "* Login ID must be exactly 3 digits"
          : ""
      );
    }
  };

  const addUser = (e) => {
    e.preventDefault();
    console.log(formValues);
    // Check if any required fields are missing
    const missingFields = Object.keys(formValues).filter((key) => {
      return key !== "loginId" && !formValues[key];
    });

    if (missingFields.length > 0) {
      toast.error("Please fill in all required fields.");
      return;
    }

    // Validate Login ID only if the role is 'Mobile App user'
    if (formValues.role === "4" && !/^\d{3}$/.test(formValues.loginId)) {
      toast.error("Login ID must be exactly 3 digits for Mobile App user.");
      return;
    }

    // Perform email and phone number validations
    if (error || mobileError || loginIdError) {
      toast.error("Please correct the errors in the form.");
      return;
    }

    const payload = {
      FIRST_NAME: formValues.firstname,
      LAST_NAME: formValues.lastname,
      MOBILE: formValues.phonenumber,
      EMAIL: formValues.email,
      GENDER: formValues.gender,
      CITY: formValues.city,
      STATE: formValues.state,
      REGION: formValues.region,
      PASSWORD: formValues.password,
      ROLE: formValues.role,
      LOGIN_ID: formValues.role === "4" ? formValues.loginId : null,
      Status: 0,
    };
    console.log("Submitting addUser payload:", payload);

    Axios.post(`${config.baseUrl}/addUser`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setData([...data, payload]);

          // Reset form values
          setFormValues({
            firstname: "",
            lastname: "",
            email: "",
            phonenumber: "",
            gender: "",
            city: "",
            state: "",
            region: "",
            password: "",
            role: "",
            loginId: "",
          });
          toast.success("User Added Successfully");
        } else if (response.status === 301) {
          toast.error(response.data.error.message);
        }
      })
      .catch((error) => {
        toast.error(
          error.response?.data?.error?.message ||
          "Error adding user. Please try again."
        );
      });
  };

  return (
    <div>
      <h3 className="pageheading">User Creation</h3>
      <MDBCard
        style={{
          background: "#F3F3F3",
          borderRadius: "12px",
          boxShadow: "none",
        }}
      >
        <MDBCardHeader className="userCreateCardHeader" id="UserCreation">
          <p>User Details</p>
        </MDBCardHeader>
        <MDBCardBody>
          <form className="user-form">
            <div className="user-form-container">
              <div className="user-form-row">
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="firstname">
                    First Name *
                  </label>
                  <input
                    className="user-form-input"
                    type="text"
                    id="firstname"
                    name="firstname"
                    value={formValues.firstname}
                    placeholder="First Name"
                    onChange={(e) => onChangealpha(e, "firstname", e.target.value)}
                  />
                </div>
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="lastname">
                    Last Name *
                  </label>
                  <input
                    className="user-form-input"
                    type="text"
                    id="lastname"
                    name="lastname"
                    value={formValues.lastname}
                    placeholder="Last Name"
                    onChange={(e) => onChangealpha(e, "lastname", e.target.value)}
                  />
                </div>
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="email">
                    Email *
                  </label>
                  <input
                    className="user-form-input"
                    type="text"
                    id="email"
                    name="email"
                    value={formValues.email}
                    placeholder="Email"
                    onChange={handleEmailChange}
                  />
                </div>
              </div>
              <div className="user-form-row">
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="mobile">
                    Mobile No *
                  </label>
                  <input
                    className="user-form-input"
                    type="text"
                    id="mobile"
                    name="mobile"
                    value={formValues.phonenumber}
                    placeholder="Phone Number"
                    maxLength={10}
                    onChange={handleMobileChange}
                  />
                </div>
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="gender">
                    Gender *
                  </label>
                  <select
                    className="user-form-select"
                    id="gender"
                    value={formValues.gender}
                    onChange={(e) => onChangeA(e, "gender", e.target.value)}
                  >
                    <option value="" disabled>
                      Choose Gender
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="others">Others</option>
                  </select>
                </div>
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="city">
                    City *
                  </label>
                  <select
                    className="user-form-select"
                    id="city"
                    name="city"
                    value={formValues.city}
                    onChange={handleCityChange}
                  >
                    <option value="">Select City</option>
                    <option value="Vishakapatnam">Vishakapatnam</option>
                    <option value="Sonipat">Sonipat</option>
                  </select>
                </div>
              </div>
              <div className="user-form-row">
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="state">
                    State *
                  </label>
                  <select
                    className="user-form-select"
                    id="state"
                    name="state"
                    value={formValues.state}
                    disabled
                  >
                    <option value="">Select State</option>
                    <option value="Andhra Pradesh">Andhra Pradesh</option>
                    <option value="Haryana">Haryana</option>
                  </select>
                </div>
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="region">
                    Region *
                  </label>
                  <select
                    className="user-form-select"
                    id="region"
                    name="region"
                    value={formValues.region}
                    onChange={(e) => onChangeA(e, "region", e.target.value)}
                  >
                    <option value="">Select Region</option>
                    <option value="Urban">Urban</option>
                    <option value="Rural">Rural</option>
                  </select>
                </div>
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="role">
                    Role *
                  </label>
                  <select
                    className="user-form-select"
                    id="role"
                    value={formValues.role}
                    onChange={(e) => onChangeA(e, "role", e.target.value)}
                  >
                    <option value="" disabled>
                      Select Role
                    </option>
                    <option value="0">Web Admin</option>
                    <option value="10">Vishakapatnam Project SP</option>
                    <option value="20">Sonipat Project SP</option>
                    <option value="11">Vishakapatnam Data SP</option>
                    <option value="21">Sonipat Data SP</option>
                    <option value="4">Mobile App user</option>
                  </select>
                </div>
              </div>
              {/* Conditionally render Login ID field */}
              <div className="user-form-row">
                {formValues.role === "4" && (
                  <div className="user-form-field">
                    <label className="user-form-label" htmlFor="loginId">
                      Login ID *
                    </label>
                    <input
                      className="user-form-input"
                      type="text"
                      id="loginId"
                      name="loginId"
                      placeholder="Login ID"
                      maxLength={3}
                      value={formValues.loginId}
                      onChange={handleLoginIdChange}
                    />
                    {loginIdError && (
                      <span className="error-text">{loginIdError}</span>
                    )}
                  </div>
                )}
                <div className="user-form-field">
                  <label className="user-form-label" htmlFor="mobile">
                    Password *
                  </label>
                  <input
                    className="user-form-input"
                    type="text"
                    id="password"
                    name="password"
                    placeholder="password"
                    maxLength={10}
                    value={formValues.password}
                    onChange={(e) => onChangeA(e, "password", e.target.value)}
                  />
                </div>{" "}
              </div>
            </div>
            <button className="user-form-button" onClick={addUser}>
              Add User
            </button>
          </form>

          <ToastContainer />
        </MDBCardBody>
      </MDBCard>
    </div>
  );
};

export default DashboardUserCreat;